var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchpadDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 3.83339C4.18042 3.83429 3.57601 3.84894 3.10752 4.08765C2.66847 4.31136 2.31152 4.66831 2.08781 5.10736C1.8335 5.60648 1.8335 6.25988 1.8335 7.56667V18.7667C1.8335 20.0735 1.8335 20.7269 2.08781 21.226C2.31152 21.665 2.66847 22.022 3.10752 22.2457C3.60665 22.5 4.26004 22.5 5.56683 22.5H14.4335C15.7403 22.5 16.3937 22.5 16.8928 22.2457C17.3319 22.022 17.6888 21.665 17.9125 21.226C18.1668 20.7269 18.1668 20.0735 18.1668 18.7667V7.56667C18.1668 6.25988 18.1668 5.60648 17.9125 5.10736C17.6888 4.66831 17.3319 4.31136 16.8928 4.08765C16.4243 3.84894 15.8199 3.83429 14.6668 3.83339M5.3335 3.83339V6.16667H14.6668V3.83339M5.3335 3.83339V3.49162C5.3335 2.96341 5.54333 2.45684 5.91683 2.08333C6.29033 1.70983 6.79691 1.5 7.32512 1.5H12.6752C13.2034 1.5 13.71 1.70983 14.0835 2.08333C14.457 2.45684 14.6668 2.96341 14.6668 3.49162V3.83339M14.6668 10.8333H12.3335M14.6668 16.6667H12.3335M5.3335 10.8333L6.50016 12L8.8335 9.66667M5.3335 16.6667L6.50016 17.8333L8.8335 15.5",
    stroke: "#8E97CD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpadDetailsIcon);
export default __webpack_public_path__ + "static/media/launchpadDetailsIcon.19535a77d7e7fd7587a33e5c7068135a.svg";
export { ForwardRef as ReactComponent };